/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { memo, useEffect, useState } from "react";
import { useFormik } from "formik";
import Button from "@mui/material/Button";
import store from "src/redux/store";
import { setPincodeData } from "src/redux/Actions/proposerDetails";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { setStepDetails } from "src/redux/Actions/common";
import { setProposerAddressPostDetails } from "src/redux/Thunk";
import {
  initialValues,
  validationSchema
} from "../../../../helpers/FormDetails/ProposalDetails/AddressDetails";
import SecondaryDetails from "./SecondaryDetails";
import CustomModal from "../../../../shared/CustomModal";

function AddressDetails() {
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const secondaryDetailsSchema = mefSchema?.secondaryDetailsSchema || {};
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [isPinCodeInvalid, setIsPinCodeInvalid] = useState(false);
  const addressDetails = useAppSelector((state) => state.proposerDetails.address) || initialValues;
  // const leadId = useAppSelector((state) => state.common.leadId);
  // const tableData = useAppSelector((state) => state.dashboard.tableData);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const handlePincodeClick = (data: any) => store.dispatch(setPincodeData(data));
  const { lifeAssuredDetails: { address } = {} as any } =
    useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema) || {};

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: addressDetails,
    validationSchema: validationSchema(isPinCodeInvalid, address),
    onSubmit: (fieldValues) => {
      if (proposalStatus !== "MEF Submitted") {
        store.dispatch(setProposerAddressPostDetails(fieldValues, { proposerStepNo: 3 }));
        window.scrollTo(0, 0);
      }
    }
  });

  useEffect(() => {
    // console.log("Fetching proposer address details from redux", addressDetails);
    formik.setValues(addressDetails || initialValues);
  }, []);

  const handleProposerAddressForm = () => {
    if (!formik.isValid || isPinCodeInvalid) setModalOpen(true);
    formik.handleSubmit();
  };
  // console.log("Address formik values", formik.values, formik.errors, formik.touched);
  return (
    <>
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className="pr-10 pl-10.25 pt-8">
        <SecondaryDetails
          formik={{
            errors: formik.errors,
            values: formik.values,
            touched: formik.touched,
            formikHandlers: formik
          }}
          savePincodeDataToStore={handlePincodeClick}
          setIsPinCodeInvalid={setIsPinCodeInvalid}
          secondaryDetailsSchema={secondaryDetailsSchema}
        />
        <div className="mt-10 flex justify-center">
          <Button
            variant="outlined"
            classes={{ outlined: "!rounded-lg" }}
            onClick={() => {
              dispatch(setStepDetails({ proposerStepNo: 1 }));
              window.scrollTo(0, 0);
            }}
            className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
          >
            Back
          </Button>
          <Button
            variant="contained"
            classes={{ contained: "!rounded-lg" }}
            onClick={handleProposerAddressForm}
            className="!uppercase h-13 w-37.5"
          >
            NEXT
          </Button>
        </div>
      </div>
    </>
  );
}

export default memo(AddressDetails);
